

import React, { useState } from 'react';
import DatabasePage from './database';


function JfsAdmin() {
  const [selectedMenu, setSelectedMenu] = useState('database');

  return (
    <div style={{ display: 'flex', minHeight: '60vh', background: '#fafbfc', borderRadius: 8, boxShadow: '0 2px 8px #eee', overflow: 'hidden' }}>
      {/* Left Pane: Menu */}
      <div style={{ width: 200, background: '#f4f6f8', borderRight: '1px solid #e0e0e0', padding: '2rem 1rem', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <h3 style={{ fontWeight: 'bold', fontSize: '1.1rem', marginBottom: 24, color: '#333' }}>Admin Configuration</h3>
        <button
          style={{
            background: selectedMenu === 'database' ? '#1976d2' : '#fff',
            color: selectedMenu === 'database' ? '#fff' : '#333',
            border: '1px solid #d1d5db',
            borderRadius: 4,
            padding: '0.5rem 1rem',
            marginBottom: 12,
            fontWeight: 'bold',
            cursor: 'pointer',
            width: '100%',
            textAlign: 'left',
            boxShadow: '0 1px 2px #e0e0e0',
            fontSize: '1rem',
            transition: 'background 0.2s, color 0.2s',
          }}
          onClick={() => setSelectedMenu('database')}
        >
          Database
        </button>
        {/* Add more menu items here as needed */}
      </div>

      {/* Right Pane: Content */}
      <div style={{ flex: 1, padding: '2rem', overflowX: 'auto', width: '100%' }}>
        {selectedMenu === 'database' && <DatabasePage />}
        {/* Add more conditional renders for other menu items here */}
      </div>
    </div>
  );
}

export default JfsAdmin;
